import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    const element = document.getElementById('verification-code');
    if (element) {
      element.classList.remove('tw-hidden');
    }
  }
}
